import { isHexColor } from 'lib/helpers/luminance';

// `labelClasses` mirror Typography's `span` variant for the matching size (see
// Typography/lib/variants.js) so the label keeps its type scale without the wrapper.
const SIZES = {
  small: {
    height: 'h-[20px]',
    spacing: 'p-[2px]',
    iconSize: 14,
    labelClasses: 'text-xs leading-[14px]'
  },
  medium: {
    height: 'h-[24px]',
    spacing: 'p-[3px]',
    iconSize: 16,
    labelClasses: 'text-xs leading-[14px]'
  },
  large: {
    height: 'h-[28px]',
    spacing: 'p-[4px]',
    iconSize: 18,
    labelClasses: 'text-sm leading-4'
  }
};

const DEFAULT_SIZE = 'small';

/**
 * Resolves size classes plus the background treatment for a tag. A color is either a
 * design-system token ('primary', 'success', …) rendered via Tailwind classes, or a raw hex
 * value rendered via an inline style.
 */
export const getClasses = (size, variant, color) => {
  const classes = { ...(SIZES[size] || SIZES[DEFAULT_SIZE]) };

  if (isHexColor(color)) {
    classes.colorClasses = '';
    classes.style = { backgroundColor: color };
    return classes;
  }

  classes.colorClasses = variant === 'dark' ? `bg-${color}-200` : `bg-${color}-50`;
  classes.style = undefined;
  return classes;
};
